import type { MarketplaceDynamicFilter } from "@/types/api/marketplace";

/** Filters shown inside the Filters modal. */
export function getMarketplaceModalFilters(
  filters: MarketplaceDynamicFilter[]
): MarketplaceDynamicFilter[] {
  return filters.filter((filter) => filter.placement === "modal");
}
